import React from 'react';
import PropTypes from 'prop-types';

const EstimateShared = props => (
  <div className="shareModalBody modal-body">
    <span className="shareConfirmationModalText">
      A link to the estimate(s) was successfully sent.
    </span>
    <button
      className="shareConfirmationModalGotItButton btn btn-primary"
      onClick={props.close}
    >
    Got it
    </button>
  </div>
);

EstimateShared.propTypes = {
  close: PropTypes.func.isRequired,
};

export default EstimateShared;
